import {
    ThemeProvider, Stack, Drawer
} from '@mui/material'

import { useRef } from 'react'
import { useSelector } from 'react-redux'

import theme, { DRAWER_WIDTH } from '@services/theme'
import { useAppData } from '@services/store/AppData'
import { useWidth } from '@services/hooks/Width'
import { useAppDrawer } from '@services/hooks/AppDrawer'
import { useAppLoader } from '@services/hooks/AppLoader'
import { useAppSnackbar } from '@services/hooks/AppSnackbar'
import { useAppSnackbars } from '@services/hooks/AppSnackbars'

import Loader from '@components/Loader'
import Snackbar from '@components/Snackbar'
import Alert from '@components/Alert'

import Menu from './Menu'
import Header from './Header'

import Config from '@features/config.json'
import Styles from './style'

export const Layout = props => {
    useAppData()
    const dataStore = useSelector(state => state.app)

    const { show: showDrawer, hide: hideDrawer, config: drawerConfig } = useAppDrawer()
    const { hide: hideSnackbar, config: snackbarConfig } = useAppSnackbar()
    const { hideSingle: hideSingleSnackbar, config: snackbarsConfig } = useAppSnackbars()
    const { config: loaderConfig } = useAppLoader()

    const width = useWidth()

    const haveHeader = useRef(Config.interface?.header ?? true)
    const haveLeftPanel = useRef(Config.interface?.leftPanel ?? true)

    const handleDrawer = () => {
        if (drawerConfig.display) hideDrawer()
        else showDrawer()
    }

    if (dataStore.hideLeftPanel) Styles.drawerDisplayed.paddingLeft = 0
    else Styles.drawerDisplayed.paddingLeft = DRAWER_WIDTH

    const menuConfig = (width !== 'xl')
        ? { showMenuButton: true, menuOpen: drawerConfig.display, variant: 'temporary' }
        : { showMenuButton: false, menuOpen: true, variant: 'permanent' }

    const mainStyle = {
        ...Styles.body,
        ...(menuConfig.variant === 'permanent' && Styles.drawerDisplayed)
    }

    return (
        <ThemeProvider theme={theme}>
            <Loader
                message={loaderConfig.message}
                display={loaderConfig.display}
            />
            {snackbarsConfig && snackbarsConfig.items.length > 0 && (
                <Stack sx={snackbarsConfig.position}>
                    {snackbarsConfig.items.map(item => {
                        return (
                            <Alert
                                closable
                                key={item.id}
                                onClose={hideSingleSnackbar(item)}
                                severity={item.mode}
                                label={item.message}
                            />
                        )
                    })}
                </Stack>
            )}
            <Snackbar
                config={snackbarConfig}
                onClose={hideSnackbar}
            >
                <Alert
                    closable
                    onClose={hideSnackbar}
                    severity={snackbarConfig.mode}
                    label={snackbarConfig.message}
                />
            </Snackbar>
            {haveHeader.current && (<Header />)}
            {haveLeftPanel.current && !dataStore.hideLeftPanel && (
                <Drawer
                    component={'nav'}
                    open={menuConfig.menuOpen}
                    variant={menuConfig.variant}
                    sx={Styles.drawer}
                    onClose={handleDrawer}
                >
                    <Menu />
                </Drawer>
            )}
            <main
                open={drawerConfig.display}
                style={mainStyle}
                className={(drawerConfig.display) ? 'drawer-opened' : 'drawer-closed'}
            >
                {props.children}
            </main>
        </ThemeProvider>
    )
}

export default Layout